import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import { Router } from '@angular/router';
import { PrincipalService } from '../../../shared';
import { PensionCalculatorSetupService } from './pension-calculator-setup.service';
import { CalculatorSetup } from '../dto/calculatorSetup'
import { AzidValidators } from '../../../shared/validators/azid-validators';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

@Component({
  selector: 'app-pension-calculator-setup',
  templateUrl: './pension-calculator-setup.component.html',
  styleUrls: ['./pension-calculator-setup.component.css']
})
export class PensionCalculatorSetupComponent implements OnInit {

  public backspace;
  public savedData;
  public message;
  public success:boolean = false;
  public progress:boolean = false;
  public formerror:boolean = false;
  public error:boolean = false;
  public showForm:boolean = false;
  public errorMessage:string = "Server Error";
  public defaultsetupValues:Array<Object>;
  public test : CalculatorSetup;
  public showPensionResult:boolean = false;
  public ageError:boolean = false;
  public lifeExpectedError:boolean = false;
  public inflationError:boolean = false;
  public serverError:boolean=false;
  public guide = false;
  public numberMask = createNumberMask({
    prefix: '',
    suffix: '%',
    integerLimit:'3',
    allowDecimal:true,
    decimalLimit:10,
    includeThousandsSeparator:false
  });
  public yearMask = createNumberMask({
    prefix: '',
    suffix: ' Tahun',
    integerLimit:'3',
    thousandsSeparatorSymbol:''
  });
  public pensionCalcultorForm = new FormGroup({
    'inflationRate' : new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl])),
    'retirementAge' : new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl])),
    'lifeExpected' : new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl])),
    'annualDevResults' : new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl])),
    'avgSalaryIncYear' : new FormControl('', Validators.compose([Validators.required, AzidValidators.isSetupCalculatorValidWithFormControl]))
  });
    // public pensionCalcultorForm: FormGroup;
    public inflationRate: AbstractControl = this.pensionCalcultorForm.get('inflationRate');
    public retirementAge: AbstractControl = this.pensionCalcultorForm.get('retirementAge');
    public lifeExpected: AbstractControl = this.pensionCalcultorForm.get('lifeExpected');
    public annualDevResults: AbstractControl = this.pensionCalcultorForm.get('annualDevResults');
    public avgSalaryIncYear: AbstractControl = this.pensionCalcultorForm.get('avgSalaryIncYear');

  constructor(public pensionSetupService: PensionCalculatorSetupService,
              public principal: PrincipalService,
              public router: Router) {
    this.inflationRate = this.pensionCalcultorForm.get('inflationRate');
    this.retirementAge = this.pensionCalcultorForm.get('retirementAge');
    this.lifeExpected = this.pensionCalcultorForm.get('lifeExpected');
    this.annualDevResults = this.pensionCalcultorForm.get('annualDevResults');
    this.avgSalaryIncYear = this.pensionCalcultorForm.get('avgSalaryIncYear');
    this.principal.identity(true).then((account) => {
      if (account == null) {
        this.router.navigate(['login']);
        this.serverError = true;
      }
    },(error) => {
      this.router.navigate(['login']);
      this.serverError = true;
    });
  }

  ngOnInit() {
    this.setDefaultValue();

  }
  public maskT(val){
    let maskVal;
    if(val==1){
      maskVal = (this.retirementAge.value).replace(' Tahun','');
    }
    if(val==2){
      maskVal = (this.lifeExpected.value).replace(' Tahun','');
    }
    let maskArray =[];
    if(maskVal.length===1){
      maskArray = [/[1-9]/,' Tahun'];
    }else{
      for(var i=0;i<=maskVal.length;i++){
        if(i==0){
          maskArray.push(/[1-9]/)
        }
        maskArray.push(/\d/)
      }

      maskArray.push(' Tahun');
    }
    return maskArray;
  }
  public setDefaultValue(){
    this.progress = true;
    this.formerror = false;
    let val = 1;
    this.pensionSetupService.getDefaultSetupValues(val)
      .subscribe(
        (response) => {
          this.progress = false;
          this.showForm = true;
          this.formerror = false;
          this.defaultsetupValues = response;
          this.inflationRate.patchValue(this.defaultsetupValues['inflationRate']+"%");
          this.retirementAge.patchValue(this.defaultsetupValues['retirementAge']+" Tahun");
          this.lifeExpected.patchValue(this.defaultsetupValues['lifeExpected']+" Tahun");
          this.annualDevResults.patchValue(this.defaultsetupValues['annualDevResults']+"%");
          this.avgSalaryIncYear.patchValue(this.defaultsetupValues['avgSalaryIncYear']+"%");
        },
        (error) => {
          this.showForm = false;
          this.formerror = true;
          // console.log('Some error has occurred while retrieving Quotation Comparison Data in Quotation Component');
        }
      );
  }

  public calculatePension(){
    this.showPensionResult = true;
  }
  handlePercentageInputControl(event, val, suffix) {
    if (val == 1) {
      var inputControlValue = this.inflationRate.value;
    }
    if (val == 2) {
      var inputControlValue = this.annualDevResults.value;
    }
    if (val == 3) {
      var inputControlValue = this.avgSalaryIncYear.value;
    }
    if(inputControlValue.length>3&&event.keyCode!=8){
      event.preventDefault();
    } else {
      var pressedKey = event.key;
      var currentNumber = this.getCurrentNumberBySuffix(inputControlValue,suffix);
      if(pressedKey === "0"||pressedKey === "1"||pressedKey === "2"||pressedKey === "3"||pressedKey === "4"||pressedKey === "5"||pressedKey === "6"||pressedKey === "7"||pressedKey === "8"||pressedKey === "9"){
        if((parseInt(currentNumber + pressedKey) < 101) && val!=1){

          if (val == 2) {
            this.annualDevResults.patchValue( currentNumber + pressedKey + suffix);
          }
          if (val == 3) {
            this.avgSalaryIncYear.patchValue( currentNumber + pressedKey + suffix);
          }
        }
        if(parseInt(currentNumber + pressedKey) < 21){
          if (val == 1) {
            this.inflationRate.patchValue( currentNumber + pressedKey + suffix);
          }
        }
      } else if(event.keyCode == 8){
        event.preventDefault();
        var modifiedNumber =  currentNumber;
        modifiedNumber = modifiedNumber.substring(0,modifiedNumber.length-1);
        if (val == 1) {
          this.inflationRate.patchValue(modifiedNumber + suffix)
        }
        if (val == 2) {
          this.annualDevResults.patchValue(modifiedNumber + suffix);
        }
        if (val == 3) {
          this.avgSalaryIncYear.patchValue(modifiedNumber + suffix);
        }
      }
      if(event.keyCode != 8)
        event.preventDefault();
    }
  }
  handleTahunInputControl(event, val, suffix) {
    if (val == 1) {
      var inputControlValue = this.retirementAge.value;
    }
    if (val == 2) {
      var inputControlValue = this.lifeExpected.value;
    }
    if(inputControlValue.length > 8 && event.keyCode!=8){
      event.preventDefault();
    } else {
      var pressedKey = event.key;
      var currentNumber = this.getCurrentNumberBySuffixChange3(inputControlValue,suffix);
      if(pressedKey === "0"||pressedKey === "1"||pressedKey === "2"||pressedKey === "3"||pressedKey === "4"||pressedKey === "5"||pressedKey === "6"||pressedKey === "7"||pressedKey === "8"||pressedKey === "9"){
          if(parseInt(currentNumber+pressedKey) < 101){
            if (val == 1) {
              this.retirementAge.patchValue( currentNumber+pressedKey + suffix);
            }
            if (val == 2) {
              this.lifeExpected.patchValue( currentNumber+pressedKey + suffix);
            }
          }
        } else if(event.keyCode == 8){
            event.preventDefault();
            var modifiedNumber =  currentNumber;
            modifiedNumber = modifiedNumber.substring(0,modifiedNumber.length-1);
            if (val == 1) {
              this.retirementAge.patchValue( modifiedNumber + suffix)
            }
            if (val == 2) {
              this.lifeExpected.patchValue( modifiedNumber + suffix)
            }
         }

      if(event.keyCode != 8){
        event.preventDefault();
      }
     }
  }

  getCurrentNumberBySuffixChange3(inputControlValue,val) {
    var list = inputControlValue.split(val);
    return list[0];
  }

  getCurrentNumberBySuffix(inputControlValue,val) {
    var list = inputControlValue.split(val);
    return list[0];
  }
  isNumber(evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      evt = (evt) ? evt : window.event;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
    return true;
  }
  isBackspace(event) {
    this.backspace = 8;
    if (event.keyCode == this.backspace){
      event.stopPropagation();
    }
  }
  updateSetupValues(){
    this.success = false;
    this.savedData = {
      'inflationRate' : (this.inflationRate.value).replace('%',''),
      'retirementAge' : (this.retirementAge.value).replace(/[^0-9]/g,''),
      'lifeExpected' : (this.lifeExpected.value).replace(/[^0-9]/g,''),
      'annualDevResults' :  (this.annualDevResults.value).replace('%',''),
      'avgSalaryIncYear' : (this.avgSalaryIncYear.value).replace('%','')
    };
    this.pensionSetupService.updateSetUpValues(this.savedData).subscribe(
      data => {
       this.formerror = false;
       if (data.message == "SUCCESS") {
         this.success = true;
         this.message = data.message;
         this.setDefaultValue();
       } else {
         this.success = false;
         this.message = data.message;
       }
      },
      error => {
        this.formerror = true;
      });
  }
  setupFormValidation(){
      this.inflationRate = (this.inflationRate.value).replace('%','');
      this.retirementAge = (this.retirementAge.value).replace(' Tahun','');
      this.lifeExpected = (this.lifeExpected.value).replace(' Tahun','');
      this.annualDevResults =  (this.annualDevResults.value).replace('%','');
      this.avgSalaryIncYear = (this.avgSalaryIncYear.value).replace('%','');
     if((this.inflationRate) && (this.retirementAge) && (this.lifeExpected) && (this.annualDevResults) && (this.avgSalaryIncYear)){
       return true;
     } else {
       return false;
     }
  }
  public handlePercentage(event,val) {
    let formcontrolval;
    if(val==1) {
      formcontrolval = (this.annualDevResults.value).replace('%', '');
    }
    if(val==2){
      formcontrolval = (this.avgSalaryIncYear.value).replace('%','');
    }
    if(formcontrolval>100 && val==1){
      this.annualDevResults.patchValue('');
    }
    if(formcontrolval>100 && val==2){
      this.avgSalaryIncYear.patchValue('');
    }

  }
  public handleLifeExpectedError(event){
    let retireAge = (this.retirementAge.value).replace(/[^0-9]/g,'');
    let lifeExpected = (this.lifeExpected.value).replace(/[^0-9]/g,'');
    if(parseInt(lifeExpected) < parseInt(retireAge)){
      this.lifeExpectedError = true;
    }
    if(parseInt(lifeExpected) > 100){
      this.lifeExpected.patchValue('');
      this.lifeExpectedError = false;
    }
    if(parseInt(lifeExpected) > parseInt(retireAge)){
      this.lifeExpectedError = false;
    }
  }
  public handlePensionAgeError(event){
    let lifeExpected = this.lifeExpected.value.replace(/[^0-9]/g,'');
    if(parseInt(lifeExpected) > parseInt((this.retirementAge.value).replace(/[^0-9]/g,''))){
      this.lifeExpectedError = false;
    }
    if(parseInt((this.retirementAge.value).replace(/[^0-9]/g,'')) > 100){
      this.retirementAge.patchValue('');
      this.ageError = false;
    }
    if(parseInt(lifeExpected) < parseInt((this.retirementAge.value).replace(/[^0-9]/g,''))){
      this.lifeExpectedError = true;
    }
  }
  public handleInflationRate(event){
    let inflation = (this.inflationRate.value).replace('%','');
    if(inflation > 20){
      this.inflationError = true;
      this.inflationRate.patchValue('');
      event.preventDefault();
    }
    if(inflation <= 20){
      this.inflationError = false;
    }
  }
}
